// export const SERVER_NAME: string = "http://192.168.1.9:8000/";
// export const SERVER_NAME: string = "http://192.168.2.117:8000/";
// export const SERVER_NAME: string = "http://localhost:8000/";
// export const SERVER_NAME: string = "https://cmmserver.cywiretech.com/";
export const SERVER_NAME: string = "https://secure.cleverapp.it/";
export const API_URL: string = SERVER_NAME + "api/v1/";
export const NO_IMAGE_URL: string = SERVER_NAME + "static/images/_noimage.jpg";
export const EMPTY_IMAGE_URL: string = SERVER_NAME + "static/images/_empty.png";
export const API_SHOP_URL: string = API_URL + "CMMShop/";
export const API_PLUS_URL: string = API_URL + "CMMPlus/";

export const TOKEN = '800e58c9eba1e0e290b88b170eea5ebdf894b3e3'; // Produzione
// export const TOKEN = '41f030b0bde5b1fd6aed524674be0bc53a52790e'; // Debug

export const genericGETRequest = (authToken: string): RequestInit => {
    return {
        method: "GET",
        headers: { Authorization: "Token " + authToken }
    };
};

export const genericPOSTRequest = (authToken: string, body?: any): RequestInit => {
    return {
        method: "POST",
        headers: {
            Authorization: "Token " + authToken,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body),
    };
};


export const formatDate = (dateString: string): string =>  {
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
}
